<div [ngClass]="cardClass" class="bg-white rounded-lg shadow-sm border border-[#DBE0E6] p-4 md:px-5 md:py-4">
  <ng-content></ng-content>
</div>

